import React from "react";
import { Tabs, Tab } from "react-bootstrap";

import ListCharges from "components/menu/invoicing/merchandiser/list-charges";
import ListInvoices from "components/menu/invoicing/merchandiser/list-invoices";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import UserTypes from "../../../auth/user-types";
import moment from "moment";
import { toast } from "react-toastify";
import MerchandiserInvoicingStatuses from "../../../../data/merchandiser-invoicing-statuses";
import { bindActionCreators } from "redux";
import {
    approveMerchandiserInvoices,
    fetchMerchandiserInvoicingCharges,
    fetchMerchandiserPdfInvoice, submitMerchandiserInvoices
} from "../../../../api/menu/invoicing/actions";
import { deleteMiscChargeById } from "../../../../api/menu/master-files/misc-charges/actions";
import { closeCustomModal, openCustomModal } from "../../../custom/modals";
import PdfViewerModal from "../customer/pdf-viewer-modal";
import MiscCharges from "./misc-charges";

class MerchandiserInvoicingList extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.statusesArray = Object.keys(MerchandiserInvoicingStatuses)
            .map(key => ({
                label: MerchandiserInvoicingStatuses[key].title,
                value: MerchandiserInvoicingStatuses[key].value
            }));

        this.tabs = {
            charges: "charges",
            invoices: "invoices",
            miscCharges: "miscCharges"
        };

        this.state = {
            filters: {
                fromDate: moment()
                    .startOf("month"),
                toDate: moment(),
                jobId: null,
                status:  this.props.userRole.includes(UserTypes.accountManager) || this.props.userRole.includes(UserTypes.admin)
                ? this.statusesArray.find(x => x.label === "Not Approved Yet")
                : this.statusesArray.find(x => x.label === "All Charges"),
                manualEntryOnly: false,
                accountManagerId: null,
                merchandiserId: null,
            },
            selectedMiscCharges: {},
            selectedCharges: {}
        };

        this.handleSelect = this.handleSelect.bind(this);
        this.handleApprove = this.handleApprove.bind(this);
        this.handleSubmitInvoice = this.handleSubmitInvoice.bind(this);
        this.handleLoad = this.handleLoad.bind(this);
        this.handleViewPreliminaryInvoice = this.handleViewPreliminaryInvoice.bind(this);
    }

    getRequestData = () => {
        const { userRole } = this.props;
        const {
            fromDate,
            toDate,
            jobId,
            status,
            manualEntryOnly,
            accountManagerId,
            merchandiserId
        } = this.state.filters;

        const requestData = {};

        if (fromDate) {
            requestData.fromDate = moment(fromDate)
                .format(this.dateFormat);
        }
        if (toDate) {
            requestData.toDate = moment(toDate)
                .format(this.dateFormat);
        }
        if (jobId) {
            requestData.jobId = jobId.value;
        }
        if (status) {
            requestData.status = status.value;
        }

        const isAdminView = userRole.includes(UserTypes.admin) || userRole.includes(UserTypes.accountManager);
        if (isAdminView) {
            requestData.manualEntryOnly = manualEntryOnly;

            if (accountManagerId) {
                requestData.accountManagerId = accountManagerId.value;
            }

            if (merchandiserId) {
                requestData.merchandiserId = merchandiserId.value;
            }
        }

        return requestData;
    };

    handleSelect = (name, option) => {
        const filters = Object.assign({}, this.state.filters);
        filters[name] = option;
        this.setState({
            filters
        });
    };

    handleApprove = () => {
        const {
            selectedCharges,
            selectedMiscCharges
        } = this.state;
        const data = Object.keys(selectedCharges)
            .concat(Object.keys(selectedMiscCharges))
            .map(id => parseInt(id, 10));
        if (!data.length) {
            toast("Please select one or more charges.", {
                type: toast.TYPE.WARNING,
            });
            return false;
        }
        this.props.approveMerchandiserInvoices(data, () => {
            this.setState({
                selectedCharges: {},
                selectedMiscCharges: {}
            }, this.handleLoad);
        });
    };

    handleSubmitInvoice = () => {
        const {
            user,
            userRole
        } = this.props;
        const data = Object.assign({}, this.getRequestData());
        const keywords = ["jobId", "merchandiserId", "fromDate", "toDate"];
        // eslint-disable-next-line no-restricted-syntax,guard-for-in
        for (const key in data) {
            if (keywords.indexOf(key) === -1) {
                delete data[key];
            }
        }

        if (!data.jobId) {
            data.jobId = null;
        }

        if (userRole.includes(UserTypes.merchandiser)) {
            data.merchandiserId = parseInt(user.nameid, 10);
        }

        this.props.submitMerchandiserInvoices(data, this.handleLoad);
    };

    handleLoad = () => {
        this.props.fetchMerchandiserInvoicingCharges(this.getRequestData());
    };

    handleSelectMiscCharge = (miscCharge) => {
        this.setState({
            selectedMiscCharges: miscCharge
        });
    };

    handleSelectCharge = (charge) => {
        this.setState({
            selectedCharges: charge
        });
    };

    handleViewPreliminaryInvoice = () => {
        this.props.fetchMerchandiserPdfInvoice(this.getRequestData(), (pdfData) => {
            const modalObj = {
                id: "view-preliminary-invoice",
                modalSettings: {
                    size: "lg",
                    style: {
                        top: 20,
                        width: "calc(100% - 40px)"
                    },
                },
                header: "View Preliminary Invoice",
                children: (
                    <React.Suspense fallback={<div
                        className="m-2 text-center font-weight-bold">Loading...</div>}>
                        <PdfViewerModal
                            pdfData={pdfData}
                            name="preliminary-invoice.pdf"
                        />
                    </React.Suspense>
                ),
                handleClose: () => this.props.closeCustomModal(modalObj)
            };
            this.props.openCustomModal(modalObj);
        });
    };

    setSelectedCharges = (selectedCharges) => {
        this.setState({
            selectedCharges
        });
    }

    render() {
        const { auth, charges } = this.props;
        const { selectedCharges, selectedMiscCharges } = this.state;
        return (
            <div className="dashboard">
                <Tabs
                    id="invoicing-tabs"
                    defaultActiveKey={this.tabs.charges}
                    className="w-100"
                    unmountOnExit={true}
                >
                    <Tab
                        eventKey={this.tabs.charges}
                        title="Charges"
                    >
                        <ListCharges
                            handleLoad={this.handleLoad}
                            handleViewPreliminaryInvoice={this.handleViewPreliminaryInvoice}
                            handleSelect={this.handleSelect}
                            handleApprove={this.handleApprove}
                            handleSubmitInvoice={this.handleSubmitInvoice}
                            handleSelectCharge={this.handleSelectCharge}
                            selectedCharges={selectedCharges}
                            setSelectedCharges = {this.setSelectedCharges}
                            submitIsDisabled={!(charges && charges.charges ? charges.charges : []).length}
                            filters={this.state.filters}
                        />
                    </Tab>
                    <Tab
                        eventKey={this.tabs.miscCharges}
                        title="Misc. Charges"
                    >
                        <MiscCharges
                            handleLoad={this.handleLoad}
                            handleViewPreliminaryInvoice={this.handleViewPreliminaryInvoice}
                            handleSelect={this.handleSelect}
                            handleApprove={this.handleApprove}
                            handleSubmitInvoice={this.handleSubmitInvoice}
                            handleSelectMiscCharge={this.handleSelectMiscCharge}
                            selectedMiscCharges={selectedMiscCharges}
                            submitIsDisabled={!(charges && charges.charges ? charges.charges : []).length}
                            filters={this.state.filters}
                        />
                    </Tab>
                    {auth.user.role.includes(UserTypes.accountManager) ? null : (
                        <Tab
                            eventKey={this.tabs.invoices}
                            title="Invoices"
                        >
                            <ListInvoices/>
                        </Tab>
                    )}
                </Tabs>
            </div>
        );
    }
}

MerchandiserInvoicingList.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
    auth: state.auth,
    user: state.auth.user,
    userRole: state.auth.user.role,
    charges: state.invoicing.charges
});

const mapStateToDispatch = dispatch => ({
    fetchMerchandiserInvoicingCharges:
        bindActionCreators(fetchMerchandiserInvoicingCharges, dispatch),
    fetchMerchandiserPdfInvoice: bindActionCreators(fetchMerchandiserPdfInvoice, dispatch),
    approveMerchandiserInvoices: bindActionCreators(approveMerchandiserInvoices, dispatch),
    submitMerchandiserInvoices: bindActionCreators(submitMerchandiserInvoices, dispatch),

    deleteMiscChargeById: bindActionCreators(deleteMiscChargeById, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(MerchandiserInvoicingList);
